import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import store from './store/store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { FeatureFlagsProvider } from "./contexts/FeatureFlags";


ReactDOM.render(
  <React.StrictMode>
    <FeatureFlagsProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </FeatureFlagsProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
